import script from "./ConsumptionLog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumptionLog.vue?vue&type=script&setup=true&lang=js"

import "./ConsumptionLog.vue?vue&type=style&index=0&id=4d08b66d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d08b66d"]])

export default __exports__